import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import { environment } from '../environments/environment';
@Injectable({
  providedIn: 'root'
})


export class MapMarkerService {
  constructor(private http: HttpClient) {
  }
  

  

  getBoat() {
    
    const params: any = { };
    //console.info(this.http.get(environment.url +'/mapSite/getPort', {params} ));
    return this.http.get('/BP/map/data', {params} );
    //return this.http.get(environment.url +'/BP/map/data', {params} );
  }
  
}

interface traffic {
  position: {
    lat:number,
    lng:number
  };
  name: string;
  staionId: string;
  lat: string;
  lng: string;
}